export const NotificationEmailsValues = {
  notificationEmails: [''],
}

